import React, { useMemo } from 'react'
import styles from './MicrositeEmailPreviewPane.module.css'
import { Mail } from 'lucide-react'

const SAMPLE_VALUES = {
    customerName: 'Priya Sharma',
    storeName: 'Glam Studio',
    appointmentDate: '18 June 2026, 4:00 PM',
    serviceName: 'Hair Spa & Styling'
}

/**
 * MicrositeEmailPreviewPane
 * Renders bodyHtml with sample {{variable}} values substituted, so
 * salon owners can see roughly how the email will look to a real
 * customer. Used on MicrositeEmailTemplateEditor.
 *
 * Usage:
 *   <MicrositeEmailPreviewPane subject={form.subject} bodyHtml={form.bodyHtml} />
 */
const substitute = (text = '') =>
    text.replace(/\{\{(\w+)\}\}/g, (match, key) => SAMPLE_VALUES[key] ?? match)

const MicrositeEmailPreviewPane = ({ subject, bodyHtml }) => {
    const renderedSubject = useMemo(() => substitute(subject), [subject])
    const renderedBody = useMemo(() => substitute(bodyHtml), [bodyHtml])

    return (
        <div className={styles.wrap}>
            <div className={styles.label}>Preview with sample data</div>
            <div className={styles.card}>
                <div className={styles.header}>
                    <Mail size={14} className={styles.headerIcon} />
                    <span className={styles.subject}>{renderedSubject || 'Email subject'}</span>
                </div>
                <div className={styles.body} dangerouslySetInnerHTML={{ __html: renderedBody || '<p>Email body preview will appear here.</p>' }} />
            </div>
        </div>
    )
}

export default MicrositeEmailPreviewPane